import classNames from 'classnames'

import {useBooleanQueryParamState} from '../../../../../hooks/routes'
import type {BuildId} from '../../../../../types'
import type {PreloadedEntryPoints} from '../../../../../types/entryPoints'
import PageWithSidebar from '../../components/PageWithSidebar/PageWithSidebar'
import {PipelinesTargetContext, PipelinesTarget} from '../../contexts/targetContext'
import {useVersionedSettingsStatus} from '../../hooks/useVersionedSettings'
import {isStoreYamlInVcsEnabled} from '../../utils/featureToggles'
import type {NestedEntryPoints} from '../PipelineRunPage'

import Banners from './Banners/Banners'
import JobDetails from './JobDetails/JobDetails'
import JobDetailsPopup from './JobDetailsPopup/JobDetailsPopup'
import PipelineRunChart from './PipelineRunChart/PipelineRunChart'

import styles from './PipelineTab.css'

const MIN_SIDEBAR_WIDTH = 650

type Props = {
  jobId: BuildId | null | undefined
  entryPoints: PreloadedEntryPoints<NestedEntryPoints>
}

function PipelineTab({jobId, entryPoints}: Props) {
  const [isJobDetailsFullscreen] = useBooleanQueryParamState('jobDetailsFullscreen', false)
  const isOpenSidebar = jobId != null && !isJobDetailsFullscreen
  useVersionedSettingsStatus()

  const content = (
    <>
      {isStoreYamlInVcsEnabled && <Banners />}
      <div className={styles.main}>
        <PipelineRunChart />
      </div>
    </>
  )
  const sidebar = (
    <PipelinesTargetContext.Provider value={PipelinesTarget.JOB_DETAILS_SIDEBAR}>
      <JobDetails key={jobId} jobId={Number(jobId)} entryPoints={entryPoints} />
    </PipelinesTargetContext.Provider>
  )

  return (
    <>
      <PageWithSidebar
        className={classNames(styles.pageWithSidebar, {[styles.openSidebar]: isOpenSidebar})}
        content={content}
        sidebar={isJobDetailsFullscreen ? null : sidebar}
        minSidebarWidth={MIN_SIDEBAR_WIDTH}
        maxSidebarWidth={Math.max(window.innerWidth / 2, MIN_SIDEBAR_WIDTH)}
        isOpenSidebar={isOpenSidebar}
      />
      <JobDetailsPopup jobId={jobId} entryPoints={entryPoints} />
    </>
  )
}

export default PipelineTab
